module.exports = __webpack_public_path__ + "img/refarral-new-1.28800369.png";